#!/usr/bin/env node

import { main } from './index.ts';

await main();
